import { render, staticRenderFns } from "./Investment.vue?vue&type=template&id=7e93fd0f&scoped=true&"
import script from "./Investment.vue?vue&type=script&lang=ts&"
export * from "./Investment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e93fd0f",
  null
  
)

export default component.exports